const valueAddedServiceIndex = () => import('@/pages/valueAddedService/index/index.vue')
const valueAddedServiceNewIndex = () => import('@/pages/valueAddedServiceNew/index.vue')
const TdMananger = () => import('@/pages/valueAddedService/detail/TdMananger.vue')
const TdCloudRenew = () => import('@/pages/valueAddedService/detail/TdCloudRenew.vue')

export default [
  {
    path: '/valueAddedService/index/:token/:sisscloudtokenid?/:otherData?',
    component: valueAddedServiceNewIndex,
    name: 'valueAddedServiceNewIndex',
    meta: {
      title: '增值服务'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/valueAddedService/tdManager/:token/:sisscloudtokenid?/:otherData?',
    component: TdMananger,
    name: 'TdMananger',
    meta: {
      title: '天店管家'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/valueAddedService/tdCloudRenew/:token/:sisscloudtokenid?/:otherData?',
    component: TdCloudRenew,
    name: 'TdCloudRenew',
    meta: {
      title: '云平台管理服务费'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  }
]
